import { useGetHttp } from "../../http.hook";
import type { IFavoriteSocialMinimal } from "./get-favorites-by-id.admin.http";

interface IResponse {
  favouriteSocial: {
    socials: IFavoriteSocialMinimal[];
  }[];
}

export function useSearchFavoriteSocialAdminHttp() {
  return useGetHttp<IResponse>({
    path: "/admin/favourite-socials/:id/search",
  });
}
